/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {provide$location as ɵangular_packages_common_upgrade_upgrade_d,provideAppBaseHref as ɵangular_packages_common_upgrade_upgrade_a,provideLocationStrategy as ɵangular_packages_common_upgrade_upgrade_c,provideUrlCodec as ɵangular_packages_common_upgrade_upgrade_b} from './src/location_upgrade_module';